import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

// Attach token from localStorage as fallback
api.interceptors.request.use((config) => {
    const token = localStorage.getItem("femcare_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});
